
document.addEventListener('click', function(e){
  const button = e.target.closest('[data-menu-toggle]');
  if (!button) return;

  const nav = document.querySelector('[data-mobile-menu]');
  if (!nav) return;

  nav.hidden = !nav.hidden;
  button.setAttribute('aria-expanded', nav.hidden ? 'false' : 'true');
  button.setAttribute('aria-label', nav.hidden ? 'Open menu' : 'Close menu');
});

/* Close mobile menu after a destination link is selected. */
document.addEventListener('click', function(e){
  const link = e.target.closest('[data-mobile-menu] a');
  if (!link) return;

  const nav = document.querySelector('[data-mobile-menu]');
  const button = document.querySelector('[data-menu-toggle]');
  if (nav) nav.hidden = true;
  if (button) {
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', 'Open menu');
  }
});

/* Reset mobile menu state when moving back to desktop width. */
window.addEventListener('resize', function(){
  if (window.innerWidth > 1120) {
    const nav = document.querySelector('[data-mobile-menu]');
    const button = document.querySelector('[data-menu-toggle]');
    if (nav) nav.hidden = true;
    if (button) button.setAttribute('aria-expanded', 'false');
  }
});

/* v10.9: Shopify product recommendations */
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-related-products]').forEach(async function(section){
    const productId = section.dataset.productId;
    if (!productId) return;
    try {
      const url = `${window.Shopify?.routes?.root || '/'}recommendations/products?section_id=related-products&product_id=${encodeURIComponent(productId)}&limit=6&intent=related`;
      const response = await fetch(url, {headers:{'X-Requested-With':'XMLHttpRequest'}});
      if (!response.ok) return;
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-related-grid]');
      const current = section.querySelector('[data-related-grid]');
      if (fresh && current && fresh.children.length) current.innerHTML = fresh.innerHTML;
    } catch(e) {}
  });
});

/* v10.9: AJAX add-to-cart + cart drawer */
(function(){
  function drawer(){ return document.querySelector('[data-cart-drawer]'); }
  function openDrawer(){
    const el=drawer(); if(!el)return;
    el.hidden=false; requestAnimationFrame(()=>el.classList.add('is-open'));
    document.documentElement.classList.add('cart-drawer-open');
  }
  function closeDrawer(){
    const el=drawer(); if(!el)return;
    el.classList.remove('is-open'); document.documentElement.classList.remove('cart-drawer-open');
    setTimeout(()=>{if(!el.classList.contains('is-open'))el.hidden=true},220);
  }
  async function refreshCart(){
    const root=window.Shopify?.routes?.root||'/';
    const cart=await fetch(`${root}cart.js`).then(r=>r.json());
    document.querySelectorAll('.cart-link span').forEach(el=>el.textContent=cart.item_count);
    const items=document.querySelector('[data-cart-drawer-items]');
    const total=document.querySelector('[data-cart-drawer-total]');
    if(total) total.textContent=new Intl.NumberFormat(undefined,{style:'currency',currency:cart.currency||'USD'}).format(cart.total_price/100);
    if(items){
      if(!cart.items.length){items.innerHTML='<div class="cart-drawer__empty">Your cart is empty.</div>';}
      else items.innerHTML=cart.items.map(item=>`<div class="cart-drawer__item">${item.image?`<img src="${item.image}" alt="">`:''}<div><a href="${item.url}"><strong>${item.product_title}</strong></a><span>Qty: ${item.quantity}</span><b>${new Intl.NumberFormat(undefined,{style:'currency',currency:cart.currency||'USD'}).format(item.final_line_price/100)}</b></div><a class="cart-drawer__remove" href="${root}cart/change?id=${encodeURIComponent(item.key)}&quantity=0" data-cart-remove="${item.key}">Remove</a></div>`).join('');
    }
    return cart;
  }
  document.addEventListener('submit',async function(e){
    const form=e.target.closest('form[action*="/cart/add"]');
    if(!form || form.dataset.noAjax==='true')return;
    e.preventDefault();
    const button=form.querySelector('[type="submit"]');
    if(button){button.disabled=true;button.dataset.oldText=button.textContent;button.textContent='Adding…';}
    try{
      const root=window.Shopify?.routes?.root||'/';
      const response=await fetch(`${root}cart/add.js`,{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/json'},body:new FormData(form)});
      if(!response.ok)throw new Error();
      await refreshCart(); openDrawer();
    }catch(err){form.submit();return;}
    finally{if(button){button.disabled=false;button.textContent=button.dataset.oldText||'Add to Cart';}}
  });
  document.addEventListener('click',async function(e){
    if(e.target.closest('[data-cart-drawer-close], [data-cart-drawer-overlay], [data-continue-shopping]')){e.preventDefault();closeDrawer();return;}
    const remove=e.target.closest('[data-cart-remove]');
    if(remove){e.preventDefault();const root=window.Shopify?.routes?.root||'/';await fetch(`${root}cart/change.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:remove.dataset.cartRemove,quantity:0})});await refreshCart();}
  });
  window.DCSCartDrawer={open:async function(){await refreshCart();openDrawer();},close:closeDrawer};
})();
